import { apiClient } from './apiClient';
import type { ProductFeedbackInput } from '../types/productFeedback';

export async function submitProductFeedback(input: ProductFeedbackInput): Promise<void> {
  const response = await apiClient.post('/api/agentic/product-feedback', input);
  if (response?.success !== true) throw new Error('Feedback was not saved');
}
